import Dropdown from "./components/Dropdown";
import "./App.css";

function App() {
  return (
    <div className="App">
      <h2>Should you use a dropdown?</h2>
      <Dropdown />
    </div>
  );
}

export default App;
